import { useMemo, useState } from "react";
import {
  tableIndexNumber,
  totalPages,
  parenthesisInNegativeValue,
} from "../../utils/services";
import { useCreditorList } from "../../api/get";
import { CreditorDebitorListResponse } from "../../api/types";
import { Table } from "../CustomReactTable/CustomReactTable";
import { Link } from "react-router-dom";
import ChequeListCard from "../ChequeList/ChequeListCard/ChequeListCard";
import { NoDataPage } from "../NoDataPage/NoDataPage";
import { Loader } from "../Loader/Loader";
interface ViewAlProps {
  viewAll: boolean;
}
export const CreditorList: React.FC<ViewAlProps> = ({ viewAll }) => {
  const [queryPageIndex, setQueryPageIndex] = useState(0);
  const [queryPageSize, setQueryPageSize] = useState(() => (viewAll ? 10 : 6));
  //useQuery
  const { data: creditorList, isLoading } = useCreditorList(
    queryPageIndex,
    queryPageSize,
  );

  const FormatTable = (
    array: CreditorDebitorListResponse[],
    pageIndex: number,
  ) => {
    if (array) {
      const formatData = array?.map(
        (item: CreditorDebitorListResponse, index) => {
          return {
            s_n: tableIndexNumber(pageIndex, queryPageSize, index),
            name: item?.user_info?.name || "-",
            mobile_no: item?.user_info?.mobile_no || "-",
            amount: parenthesisInNegativeValue(item?.amount),
          };
        },
      );
      return formatData;
    }
    return [];
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.N",
        accessor: "s_n",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile No.",
        accessor: "mobile_no",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
    ],
    [],
  );

  return (
    <div className="dashboard-table card-height">
      {!viewAll ? (
        <>
          {isLoading ? (
            <Loader loaderType="Spinner" />
          ) : creditorList && creditorList?.data.length > 0 ? (
            <>
              {creditorList?.data
                ?.slice(0, 5)
                ?.map((item: any, index: number) => (
                  <ChequeListCard
                    name={item?.user_info?.name}
                    mobile={item?.user_info?.mobile_no}
                    amount={item?.amount}
                    logo={item?.user_info?.name?.slice(0, 1)}
                  />
                ))}

              <Link to={`/creditor-list`} className="view-btn">
                <button
                  type="button"
                  className="content light-secondary next small-button "
                >
                  View All
                </button>
              </Link>
            </>
          ) : (
            <NoDataPage description="Looks like there are no entries here yet" />
          )}
        </>
      ) : (
        <>
          <div className="head-section">
            <p className="small-title">Creditor List</p>
          </div>
          <Table
            excelDownload={true}
            loading={isLoading}
            columns={columns}
            data={
              creditorList ? FormatTable(creditorList.data, queryPageIndex) : []
            }
            totalPages={
              creditorList &&
              totalPages(queryPageSize, creditorList.pagination.total_count)
            }
            totalEntries={creditorList && creditorList.pagination.total_count}
            queryPageIndex={queryPageIndex}
            setQueryPageIndex={setQueryPageIndex}
            queryPageSize={queryPageSize}
            setQueryPageSize={setQueryPageSize}
          />
        </>
      )}
    </div>
  );
};
